<template>
  <div class="container order-change-container">
    <div class="change-status">
      <template v-if="!paySuccess">
        <div class="status-title error">出票异常！</div>
        <div class="status-desc">
          尊敬的旅客，您好！请您在 <router-link class="seg-href" :to="orderHref">我的改期订单</router-link>中核实是否出票成功。若订单存在异常，请致电{{ hotline }}！
        </div>
      </template>
      <template v-else>
        <div class="status-title">恭喜你，购票成功！</div>
        <div class="status-timeout">将在<span class="_time">{{ timeout }}s</span> 后自动跳转改升订单：<router-link :to="orderHref">{{ changeNo }}</router-link> </div>
        <div class="marketing-text" v-if="marketingText">{{ marketingText }}</div>
      </template>
    </div>
    <div class="change-record">
      <div class="record-title">您的购票记录</div>
      <div class="record-subtitle">升舱/改期支付结果</div>
      <div class="pass-info">
        <div class="pass-item"
             v-for="(pass, passIndex) in detail.travelers"
             :key="passIndex"
        >
          <div class="order-primary-header">
            <l8-icon class="l8-icon" type="icon-lvke"/>
            <span class="header-label">{{ pass.fullName }}</span>
            <span class="header-msg">
            <span>{{ pass.certificateType | certificateType }}：{{ pass.certificateNo }}</span>
            <span>联系电话：{{ pass.mobile }}</span>
          </span>
          </div>
          <div class="change-seg-table-wrap">
            <table class="order-default-table change-seg-table">
              <thead>
              <tr>
                <td>行程</td>
                <td>起飞时间</td>
                <td>到达时间</td>
                <td>航空公司</td>
                <td>航班号</td>
                <td>机型</td>
              </tr>
              </thead>
              <tbody>
              <template v-for="(newSeg, newSegIdx) in pass.newFlightSegments">
                <tr :key="'newSeg' + newSegIdx">
                  <td>{{ newSeg.departureAirPortName }} - {{ newSeg.arrivalAirPortName}}</td>
                  <td>{{ newSeg.departureDate }} {{ newSeg.departureTime }}</td>
                  <td>{{ newSeg.arrivalDate }} {{ newSeg.arrivalTime }}</td>
                  <td>{{ newSeg.airlineName }}</td>
                  <td>{{ newSeg.flightNo }}</td>
                  <td>{{ newSeg.aircraftCode || '--' }}</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="exs-adv" v-if="servicesList?.length > 0">
        <div class="adv-title">现在，您还可以预订以下增值服务</div>
        <div class="exs-adv-list">
          <div class="adv-item" v-for="(svc, svcIndex) in servicesList" :key="svcIndex">
            <router-link :to="svc.url || '#'" :target="svc.target">
              <img class="adv-img" :src="svc.image" alt="">
            </router-link>
            <p class="adv-desc">{{ svc.title }}</p>
          </div>
        </div>
      </div>
      <div class="change-notice">
        <div class="notice-h">温馨提示</div>
        <div v-if="payResultTips" v-html="payResultTips"></div>
        <div v-else>
          <p>国内机场一股提前30-40分钟停止办理登机牌，请您合理安排到达机场的时间，凭网上购票时填写的有效证件办理登机手续，在办理完登机手续后，请您持有效证件、登机牌办理安全检査手续。甶于每天订座的旅客较多，民肮订座系统最多只能为已乘机的旅客保留7天的报销凭证行程单数据，若您乘机后超过7天，报销凭证行程单将不能补打。因此，请您HP时打印报销凭证行程单，</p>
          <p>您可以通过以下方式之一获取报销凭证行程单（发票）：</p>
          <p>1、有效身份证件到机场本航空公司售票柜台打印</p>
          <p>2、有效身份证件到市区内本航空公司售票处打印</p>
          <p>若出现已支付成功但无票号的情况，可能时因为民肮操作系统PNR失败造成，请联系客限人员处理。</p>
          <p>如有疑问，请拨打公司客服热线：{{ hotline }}。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string'
import { detailNew } from '@/apis/change'
import { syncTicketNo } from '@/apis/pay'
import Storage from '@/assets/js/storage'
import { certificateType } from '@/filters/order'
import getAppInfo from '@/utils/from'
import { userTypeMap } from '@/dicts/member'

import mixinPayCallBack from '@/components/mixinPayCallback'
import { get, some } from 'lodash'

import '@/components/l8-icon'
import '@/assets/css/l8-order-common.less'
import './index'

const mainSettings = window.__MICRO_ROOT__ ?? {}

let _mixinPayCallBack = mixinPayCallBack

export default {
  mixins: [_mixinPayCallBack],
  data () {
    return {
      detail: {},
      orderId: '',
      changeId: '',
      changeNo: '',
      paySuccess: true,
      timeout: 10,
      servicesList: [],
      outUserId: '',
      hotline: getAppInfo()?.hotline,
      airline: mainSettings.airline,
      userType: '',
      payResultTips: '',
      ifInternational: false,
      seller: mainSettings.airline,
      sellerChannel: 'C' + mainSettings.airline.toLocaleUpperCase(),
      marketingText: ''
    }
  },
  computed: {
    orderHref () {
      const query = queryString.parse(location.search)
      const { changeId, userType, ifInternational, seller, sellerChannel } = this
      return `/order/change/v2/detail?changeId=${changeId}&seller=${seller}&sellerChannel=${sellerChannel}${userType === 'CARRIER' ? '&outUserId=' + query.outUserId : ''}&ifInternational=${ifInternational}`
    }
  },
  created () {
    let query = queryString.parse(location.search)
    if (this.payCallbackParams !== null) {
      let extraParam = this.payCallbackParams
      this.changeId = extraParam.changeId
      this.orderId = extraParam.orderId
      this.outUserId = extraParam.outUserId
      this.paySuccess = extraParam.paySuccess ? extraParam.paySuccess === 'true' : true
      this.ifInternational = extraParam.ifInternational ? JSON.parse(extraParam.ifInternational) : false

      if (extraParam.seller) {
        this.seller = extraParam.seller
      }

      if (extraParam.sellerChannel) {
        this.sellerChannel = extraParam.sellerChannel
      }
    } else {
      this.changeId = query.changeId
      this.orderId = query.orderId
      this.outUserId = query.outUserId
      this.ifInternational = query.ifInternational === 'true'
      this.paySuccess = query.paySuccess ? query.paySuccess === 'true' : true
    }
    const userInfo = mainSettings.user?.get()
    if (userInfo) {
      this.userType = userTypeMap[userInfo.userType]
    }

    this.fetchChangeDetail()

    let syncFlag = Storage.getItem('syncFlag_change')

    // 防止刷新重复同步票号
    if (!syncFlag || syncFlag !== this.changeId) {
      this.fetchSyncTicketNo()
    }

    // this.updateServices()
    this.getCmsData()
  },
  methods: {
    async getCmsData () {
      try {
        const { ifInternational } = this
        const cmsData = (await mainSettings.cms?.getPageData()) || {}
        this.payResultTips = get(cmsData, !ifInternational ? 'change-pay-result-tips.notice' : 'change-pay-result-tips.internationalNotice') ?? get(cmsData, 'change-pay-result-tips.content')
      } catch (err) {}
    },
    fetchChangeDetail: async function () {
      const { airline, changeId, seller, sellerChannel } = this

      try {
        const { detail } = await detailNew({
          alineCode: airline,
          changeId,
          seller,
          sellerChannel
        })

        this.updateChangeDetail(detail)
      } catch (err) {
        this.$message.error(err.message || '订单改升失败，请稍后再试')
      }
    },
    async fetchSyncTicketNo () {
      const { airline, changeId } = this

      try {
        await syncTicketNo({
          airline,
          changeId
        })

        try {
          Storage.setItem('syncFlag_change', this.changeId, 24 * 3600000)
        } catch (e) {
          this.$message.error('您的浏览器开启了无痕浏览模式，部分功能将无法使用，请关闭无痕浏览模式。')
        }
      } catch (err) {
        this.$message.error(err.message || '票号同步失败')
      }
    },
    updateChangeDetail (detail) {
      this.showMarketingText(detail)
      this.detail = detail
      this.changeNo = detail.changeNo

      this.$nextTick(() => {
        const timer = setInterval(() => {
          if (this.timeout - 1 >= 0) {
            this.timeout = this.timeout - 1
          } else {
            clearInterval(timer)
            const { changeId, outUserId, userType, ifInternational, seller, sellerChannel } = this
            const query = {
              changeId,
              outUserId: userType === 'CARRIER' ? outUserId : '',
              ifInternational,
              seller,
              sellerChannel
            }

            this.$router.replace({ path: '/order/change/v2/detail', query })
          }
        }, 1000)
      })
    },
    showMarketingText (detail) {
      const { value: userInfo } = Storage.getItem('USER_CENTER_INFO') || {}
      const { authStatus, fullName, userCerts } = userInfo
      let selfCertFlags = []
      if (userCerts?.length) {
        selfCertFlags = userCerts.map(cert => {
          return `${fullName}${cert.certNo?.slice(-4)}`
        })
      }
      const isAuth = authStatus === 4
      const hasSelf = some(detail.travelers, (t) => {
        const travelerFlag = `${t.fullName}${t.certificateNo?.slice(-4)}`
        return selfCertFlags.includes(travelerFlag)
      })
      const hasOther = detail.travelers.length > 1 || !hasSelf
      const hasChild = some(detail.travelers, (t) => t.type === 'CHILD')

      this.marketingText = '乘机人于实际乘机之日所属自然周内登录“海南航空”APP完成实名认证，可获得“飞飞乐”现金抽奖参与资格，最高奖项48888元。'
      if (isAuth) {
        if (hasChild) {
          this.marketingText = '恭喜您获得“飞飞乐”现金抽奖活动加倍抽奖机会！12周岁以下儿童实际乘机后，乘机人对应抽奖次数*2！每周二20:00，登录“海南航空”APP，进入“飞飞乐”活动专区，观看抽奖直播。'
        } else if (hasSelf) {
          this.marketingText = '实际乘机后即可参与“飞飞乐”现金抽奖参与资格，最高奖项48888元。本次乘机抽奖机会加倍，预祝您抽得大奖！每周二20:00，登录“海南航空”APP，进入“飞飞乐”活动专区，观看抽奖直播。'
        } else if (hasOther) {
          this.marketingText = '乘机人实际乘机后可参与“飞飞乐”现金抽奖，最高奖项48888元。每周二20:00，海南航空APP，“飞飞乐”活动专区。实名认证用户可享5重购票福利。'
        }
      }
    },
    updateServices () {
      this.servicesList = window.servicesList.production
    }
  },
  filters: {
    certificateType
  }
}
</script>

<style lang="less">
.change-status {
  text-align: center;
  margin: 54px 0 18px;
}

.status-title {
  font-size: 24px;
  font-weight: bold;

  &.error {
    color: @primary-color;
  }
}

.status-timeout {
  padding-top: 20px;
  font-size: 14px;

  ._time {
    color: @primary-color;
  }
}

.status-desc {
  font-size: 12px;
  margin-top: 12px;
}

.change-record {
}

.record-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}

.record-subtitle {
  font-size: 12px;
  color: @primary-color;
  margin: 14px 0;
}

.pass-info {
}

.pass-item {
  + .pass-item {
    margin-top: 30px;
  }
}

.change-seg-table {
  &.order-default-table tbody tr td {
    padding: 14px 10px;
  }

  &.order-default-table tbody tr td:first-child {
    padding-left: 30px;
  }

  .seg-line {
    position: relative;
  }

  .seg-tip {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    color: #fff;
    text-decoration: none;

    span {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      font-style: normal;
      margin: 3px;
      font-size: 10px;
    }

    &:before {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-top: 30px solid red;
      border-right: 30px solid transparent;
    }

    &.seg-old {
      &:before {
        border-top: 30px solid #808080;
      }
    }
  }
}

.change-notice {
  margin-top: 20px;
}

.exs-adv {
  margin-top: 50px;
}

.adv-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 14px;
}

.exs-adv-list {
  width: 100%;
  text-align: center;
  display: table;

  .adv-item {
    cursor: pointer;
    display: table-cell;
  }
}

.adv-img {
  display: block;
  height: 230px;
  width: 310px;
}

.adv-desc {
  font-size: 14px;
  text-align: center;
  margin: 10px 0;
}

@media only screen and (max-width: 768px) {
  .change-seg-table-wrap {
    overflow-x: scroll;
  }

  .exs-adv-list {
    display: block;

    .adv-item {
      display: block;
    }
  }
}
</style>
